import type { AreaDict } from '../messages'

// Diálogos e barra de filtros: transação, transferência, importar fatura,
// FilterBar, ConversionIndicator. pt-BR = textos atuais do app.
const dialogs: AreaDict = {
  'pt-BR': {
    // Compartilhados
    'dlg.search': 'Buscar…',
    'dlg.searchAccount': 'Buscar conta…',
    'dlg.searchCategory': 'Buscar categoria…',
    'dlg.noCategory': 'Sem categoria',
    'dlg.account': 'Conta',
    'dlg.category': 'Categoria',
    'dlg.amount': 'Valor',
    'dlg.currency': 'Moeda',
    'dlg.date': 'Data',
    'dlg.description': 'Descrição',
    'dlg.status': 'Status',
    'dlg.paid': 'Pago',
    'dlg.pending': 'Pendente',
    'dlg.confirm': 'Confirmar',

    // TransactionFormDialog
    'dlg.tx.titleNew': 'Nova transação',
    'dlg.tx.titleEdit': 'Editar transação',
    'dlg.tx.titleDuplicate': 'Duplicar transação',
    'dlg.tx.expense': 'Despesa',
    'dlg.tx.income': 'Receita',
    'dlg.tx.optional': 'Opcional',
    'dlg.tx.selectAccount': 'Selecione a conta',
    'dlg.tx.errAmount': 'Valor inválido',
    'dlg.tx.errNegative': 'Valor não pode ser negativo',
    'dlg.tx.errDate': 'Informe a data',
    'dlg.tx.tabGeneral': 'Geral',
    'dlg.tx.tabCard': 'Cartão',
    'dlg.tx.tabFx': 'Câmbio',
    'dlg.tx.tabTags': 'Tags',
    'dlg.tx.recurringApply': 'Recorrente — aplicar a:',
    'dlg.tx.scopeOne': 'Somente esta',
    'dlg.tx.scopeFuture': 'Esta e as próximas',
    'dlg.tx.noTags': 'Nenhuma tag cadastrada. Crie tags em Configurações → Tags para marcá-las aqui.',
    'dlg.tx.statement': 'Fatura',
    'dlg.tx.statementHint': '— mês de cobrança',
    'dlg.tx.avista': 'À vista',
    'dlg.tx.parcelado': 'Parcelado',
    'dlg.tx.installCount': 'Nº de parcelas',
    'dlg.tx.installBasisQ': 'O valor acima é…',
    'dlg.tx.basisParcela': 'Da parcela',
    'dlg.tx.basisTotal': 'Total',
    'dlg.tx.installTotalAdjust': '(total {value} — ajuste 1 parcela)',
    'dlg.tx.installSaved': 'Compra parcelada em {n}x',
    'dlg.tx.amountCharged': 'Valor cobrado em {currency}',
    'dlg.tx.manualRate': 'Taxa manual',
    'dlg.tx.manualRateHint': '(1 {currency} = ? {base})',
    'dlg.tx.rateAuto': 'Automática',
    'dlg.tx.noHistRate':
      '{currency} não tem taxa histórica automática em data passada — informe se a conversão ficar pendente.',
    'dlg.tx.savedUpdatedFuture': 'Esta e as próximas atualizadas',
    'dlg.tx.savedUpdated': 'Transação atualizada',
    'dlg.tx.savedCreated': 'Transação registrada',
    'dlg.tx.saveError': 'Erro ao salvar',

    // TransferDialog
    'dlg.tr.title': 'Transferência entre contas',
    'dlg.tr.editTitle': 'Editar transferência',
    'dlg.tr.updated': 'Transferência atualizada',
    'dlg.tr.descPay': 'Escolha de qual conta sai o pagamento da fatura.',
    'dlg.tr.descTransfer': 'Move o valor de uma conta para outra (aceita moedas diferentes).',
    'dlg.tr.payWith': 'Pagar com',
    'dlg.tr.from': 'De (origem)',
    'dlg.tr.payingAccount': 'Conta que vai pagar',
    'dlg.tr.sourceAccount': 'Conta de origem',
    'dlg.tr.card': 'Cartão',
    'dlg.tr.to': 'Para (destino)',
    'dlg.tr.destAccount': 'Conta de destino',
    'dlg.tr.received': 'Recebido',
    'dlg.tr.crossNote':
      'Moedas diferentes: informe quanto saiu da origem e quanto entrou no destino (taxa efetiva da operação).',
    'dlg.tr.descOptional': '— opcional',
    'dlg.tr.descPlaceholder': 'Transferência',
    'dlg.tr.pay': 'Pagar',
    'dlg.tr.transfer': 'Transferir',
    'dlg.tr.errPayAccount': 'Selecione a conta que vai pagar',
    'dlg.tr.errAccounts': 'Selecione as contas de origem e destino',
    'dlg.tr.errSame': 'Origem e destino devem ser diferentes',
    'dlg.tr.errAmount': 'Informe um valor válido',
    'dlg.tr.errReceived': 'Informe o valor recebido no destino',
    'dlg.tr.paid': 'Fatura paga',
    'dlg.tr.done': 'Transferência registrada',
    'dlg.tr.error': 'Erro ao transferir',

    // ImportStatementDialog
    'dlg.imp.title': 'Importar fatura (foto ou PDF)',
    'dlg.imp.desc':
      'A IA lê a fatura e monta a lista abaixo. Revise categoria e valores e importe tudo de uma vez para a fatura de {month}.',
    'dlg.imp.reading': 'Lendo a fatura…',
    'dlg.imp.sendPrompt': 'Envie a foto ou o PDF da fatura',
    'dlg.imp.accepts': 'Aceita imagem (JPG/PNG) ou PDF. A IA extrai data, descrição, valor e parcelas.',
    'dlg.imp.chooseFile': 'Escolher arquivo',
    'dlg.imp.selected': 'selecionados',
    'dlg.imp.applyCurrencyAll': 'Aplicar moeda a todas',
    'dlg.imp.change': 'Trocar',
    'dlg.imp.purchases': 'Compras',
    'dlg.imp.refunds': 'estornos',
    'dlg.imp.negativeHint': 'valor negativo = estorno. Revise antes de importar.',
    'dlg.imp.rowCurrency': 'Moeda da linha',
    'dlg.imp.removeRow': 'Remover linha',
    'dlg.imp.errExtract': 'A extração falhou. Tente uma foto mais nítida ou o PDF.',
    'dlg.imp.errNone': 'Nenhum lançamento reconhecido. Tente uma imagem mais nítida ou o PDF da fatura.',
    'dlg.imp.errPickOne': 'Marque ao menos um lançamento com data e valor.',
    'dlg.imp.importedOne': '{n} lançamento importado',
    'dlg.imp.importedMany': '{n} lançamentos importados',
    'dlg.imp.errImport': 'Erro ao importar',
    'dlg.imp.importing': 'Importando…',
    'dlg.imp.importN': 'Importar {n}',

    // FilterBar
    'dlg.filter.allAccounts': 'Todas as contas',
    'dlg.filter.byAccount': 'Filtrar por conta',
    'dlg.filter.allCategories': 'Todas as categorias',
    'dlg.filter.byCategory': 'Filtrar por categoria',
    'dlg.filter.tag': 'Tag',
    'dlg.filter.allTags': 'Todas as tags',
    'dlg.filter.type': 'Tipo',
    'dlg.filter.bothKinds': 'Receita e despesa',
    'dlg.filter.onlyIncome': 'Só receitas',
    'dlg.filter.onlyExpense': 'Só despesas',
    'dlg.filter.allStatus': 'Todos status',
    'dlg.filter.clear': 'Limpar',

    // ConversionIndicator
    'dlg.conv.ariaConverted': 'Valor convertido',
    'dlg.conv.convertedTo': 'Convertido para {value}',
    'dlg.conv.rateLine': '1 {currency} = {rate} {base}',
  },
  en: {
    // Shared
    'dlg.search': 'Search…',
    'dlg.searchAccount': 'Search account…',
    'dlg.searchCategory': 'Search category…',
    'dlg.noCategory': 'No category',
    'dlg.account': 'Account',
    'dlg.category': 'Category',
    'dlg.amount': 'Amount',
    'dlg.currency': 'Currency',
    'dlg.date': 'Date',
    'dlg.description': 'Description',
    'dlg.status': 'Status',
    'dlg.paid': 'Paid',
    'dlg.pending': 'Pending',
    'dlg.confirm': 'Confirm',

    // TransactionFormDialog
    'dlg.tx.titleNew': 'New transaction',
    'dlg.tx.titleEdit': 'Edit transaction',
    'dlg.tx.titleDuplicate': 'Duplicate transaction',
    'dlg.tx.expense': 'Expense',
    'dlg.tx.income': 'Income',
    'dlg.tx.optional': 'Optional',
    'dlg.tx.selectAccount': 'Select the account',
    'dlg.tx.errAmount': 'Invalid amount',
    'dlg.tx.errNegative': 'Amount cannot be negative',
    'dlg.tx.errDate': 'Enter the date',
    'dlg.tx.tabGeneral': 'General',
    'dlg.tx.tabCard': 'Card',
    'dlg.tx.tabFx': 'Exchange',
    'dlg.tx.tabTags': 'Tags',
    'dlg.tx.recurringApply': 'Recurring — apply to:',
    'dlg.tx.scopeOne': 'Only this one',
    'dlg.tx.scopeFuture': 'This and the next ones',
    'dlg.tx.noTags': 'No tags yet. Create tags in Settings → Tags to mark them here.',
    'dlg.tx.statement': 'Statement',
    'dlg.tx.statementHint': '— billing month',
    'dlg.tx.avista': 'One-time',
    'dlg.tx.parcelado': 'Installments',
    'dlg.tx.installCount': 'Number of installments',
    'dlg.tx.installBasisQ': 'The amount above is…',
    'dlg.tx.basisParcela': 'Per installment',
    'dlg.tx.basisTotal': 'Total',
    'dlg.tx.installTotalAdjust': '(total {value} — adjust 1 installment)',
    'dlg.tx.installSaved': 'Purchase split into {n}x',
    'dlg.tx.amountCharged': 'Amount charged in {currency}',
    'dlg.tx.manualRate': 'Manual rate',
    'dlg.tx.manualRateHint': '(1 {currency} = ? {base})',
    'dlg.tx.rateAuto': 'Automatic',
    'dlg.tx.noHistRate':
      '{currency} has no automatic historical rate for a past date — enter it if the conversion stays pending.',
    'dlg.tx.savedUpdatedFuture': 'This and the next ones updated',
    'dlg.tx.savedUpdated': 'Transaction updated',
    'dlg.tx.savedCreated': 'Transaction saved',
    'dlg.tx.saveError': 'Error saving',

    // TransferDialog
    'dlg.tr.title': 'Transfer between accounts',
    'dlg.tr.editTitle': 'Edit transfer',
    'dlg.tr.updated': 'Transfer updated',
    'dlg.tr.descPay': 'Choose which account pays the statement.',
    'dlg.tr.descTransfer': 'Moves the amount from one account to another (accepts different currencies).',
    'dlg.tr.payWith': 'Pay with',
    'dlg.tr.from': 'From (source)',
    'dlg.tr.payingAccount': 'Paying account',
    'dlg.tr.sourceAccount': 'Source account',
    'dlg.tr.card': 'Card',
    'dlg.tr.to': 'To (destination)',
    'dlg.tr.destAccount': 'Destination account',
    'dlg.tr.received': 'Received',
    'dlg.tr.crossNote':
      'Different currencies: enter how much left the source and how much arrived at the destination (effective rate of the operation).',
    'dlg.tr.descOptional': '— optional',
    'dlg.tr.descPlaceholder': 'Transfer',
    'dlg.tr.pay': 'Pay',
    'dlg.tr.transfer': 'Transfer',
    'dlg.tr.errPayAccount': 'Select the paying account',
    'dlg.tr.errAccounts': 'Select the source and destination accounts',
    'dlg.tr.errSame': 'Source and destination must be different',
    'dlg.tr.errAmount': 'Enter a valid amount',
    'dlg.tr.errReceived': 'Enter the amount received at the destination',
    'dlg.tr.paid': 'Statement paid',
    'dlg.tr.done': 'Transfer saved',
    'dlg.tr.error': 'Error transferring',

    // ImportStatementDialog
    'dlg.imp.title': 'Import statement (photo or PDF)',
    'dlg.imp.desc':
      'The AI reads the statement and builds the list below. Review category and amounts and import everything at once into the {month} statement.',
    'dlg.imp.reading': 'Reading the statement…',
    'dlg.imp.sendPrompt': 'Send the photo or PDF of the statement',
    'dlg.imp.accepts': 'Accepts image (JPG/PNG) or PDF. The AI extracts date, description, amount and installments.',
    'dlg.imp.chooseFile': 'Choose file',
    'dlg.imp.selected': 'selected',
    'dlg.imp.applyCurrencyAll': 'Apply currency to all',
    'dlg.imp.change': 'Change',
    'dlg.imp.purchases': 'Purchases',
    'dlg.imp.refunds': 'refunds',
    'dlg.imp.negativeHint': 'negative amount = refund. Review before importing.',
    'dlg.imp.rowCurrency': 'Row currency',
    'dlg.imp.removeRow': 'Remove row',
    'dlg.imp.errExtract': 'Extraction failed. Try a clearer photo or the PDF.',
    'dlg.imp.errNone': 'No entries recognized. Try a clearer image or the statement PDF.',
    'dlg.imp.errPickOne': 'Select at least one entry with date and amount.',
    'dlg.imp.importedOne': '{n} entry imported',
    'dlg.imp.importedMany': '{n} entries imported',
    'dlg.imp.errImport': 'Error importing',
    'dlg.imp.importing': 'Importing…',
    'dlg.imp.importN': 'Import {n}',

    // FilterBar
    'dlg.filter.allAccounts': 'All accounts',
    'dlg.filter.byAccount': 'Filter by account',
    'dlg.filter.allCategories': 'All categories',
    'dlg.filter.byCategory': 'Filter by category',
    'dlg.filter.tag': 'Tag',
    'dlg.filter.allTags': 'All tags',
    'dlg.filter.type': 'Type',
    'dlg.filter.bothKinds': 'Income and expense',
    'dlg.filter.onlyIncome': 'Income only',
    'dlg.filter.onlyExpense': 'Expenses only',
    'dlg.filter.allStatus': 'All statuses',
    'dlg.filter.clear': 'Clear',

    // ConversionIndicator
    'dlg.conv.ariaConverted': 'Converted amount',
    'dlg.conv.convertedTo': 'Converted to {value}',
    'dlg.conv.rateLine': '1 {currency} = {rate} {base}',
  },
  es: {
    // Compartidos
    'dlg.search': 'Buscar…',
    'dlg.searchAccount': 'Buscar cuenta…',
    'dlg.searchCategory': 'Buscar categoría…',
    'dlg.noCategory': 'Sin categoría',
    'dlg.account': 'Cuenta',
    'dlg.category': 'Categoría',
    'dlg.amount': 'Importe',
    'dlg.currency': 'Moneda',
    'dlg.date': 'Fecha',
    'dlg.description': 'Descripción',
    'dlg.status': 'Estado',
    'dlg.paid': 'Pagado',
    'dlg.pending': 'Pendiente',
    'dlg.confirm': 'Confirmar',

    // TransactionFormDialog
    'dlg.tx.titleNew': 'Nueva transacción',
    'dlg.tx.titleEdit': 'Editar transacción',
    'dlg.tx.titleDuplicate': 'Duplicar transacción',
    'dlg.tx.expense': 'Gasto',
    'dlg.tx.income': 'Ingreso',
    'dlg.tx.optional': 'Opcional',
    'dlg.tx.selectAccount': 'Selecciona la cuenta',
    'dlg.tx.errAmount': 'Importe inválido',
    'dlg.tx.errNegative': 'El importe no puede ser negativo',
    'dlg.tx.errDate': 'Indica la fecha',
    'dlg.tx.tabGeneral': 'General',
    'dlg.tx.tabCard': 'Tarjeta',
    'dlg.tx.tabFx': 'Cambio',
    'dlg.tx.tabTags': 'Etiquetas',
    'dlg.tx.recurringApply': 'Recurrente — aplicar a:',
    'dlg.tx.scopeOne': 'Solo esta',
    'dlg.tx.scopeFuture': 'Esta y las siguientes',
    'dlg.tx.noTags': 'No hay etiquetas. Crea etiquetas en Configuración → Etiquetas para marcarlas aquí.',
    'dlg.tx.statement': 'Factura',
    'dlg.tx.statementHint': '— mes de cobro',
    'dlg.tx.avista': 'Al contado',
    'dlg.tx.parcelado': 'En cuotas',
    'dlg.tx.installCount': 'Nº de cuotas',
    'dlg.tx.installBasisQ': 'El importe de arriba es…',
    'dlg.tx.basisParcela': 'De la cuota',
    'dlg.tx.basisTotal': 'Total',
    'dlg.tx.installTotalAdjust': '(total {value} — ajusta 1 cuota)',
    'dlg.tx.installSaved': 'Compra en {n} cuotas',
    'dlg.tx.amountCharged': 'Importe cobrado en {currency}',
    'dlg.tx.manualRate': 'Tasa manual',
    'dlg.tx.manualRateHint': '(1 {currency} = ? {base})',
    'dlg.tx.rateAuto': 'Automática',
    'dlg.tx.noHistRate':
      '{currency} no tiene tasa histórica automática en fecha pasada — indícala si la conversión queda pendiente.',
    'dlg.tx.savedUpdatedFuture': 'Esta y las siguientes actualizadas',
    'dlg.tx.savedUpdated': 'Transacción actualizada',
    'dlg.tx.savedCreated': 'Transacción registrada',
    'dlg.tx.saveError': 'Error al guardar',

    // TransferDialog
    'dlg.tr.title': 'Transferencia entre cuentas',
    'dlg.tr.editTitle': 'Editar transferencia',
    'dlg.tr.updated': 'Transferencia actualizada',
    'dlg.tr.descPay': 'Elige de qué cuenta sale el pago de la factura.',
    'dlg.tr.descTransfer': 'Mueve el importe de una cuenta a otra (acepta monedas diferentes).',
    'dlg.tr.payWith': 'Pagar con',
    'dlg.tr.from': 'De (origen)',
    'dlg.tr.payingAccount': 'Cuenta que pagará',
    'dlg.tr.sourceAccount': 'Cuenta de origen',
    'dlg.tr.card': 'Tarjeta',
    'dlg.tr.to': 'A (destino)',
    'dlg.tr.destAccount': 'Cuenta de destino',
    'dlg.tr.received': 'Recibido',
    'dlg.tr.crossNote':
      'Monedas diferentes: indica cuánto salió del origen y cuánto entró en el destino (tasa efectiva de la operación).',
    'dlg.tr.descOptional': '— opcional',
    'dlg.tr.descPlaceholder': 'Transferencia',
    'dlg.tr.pay': 'Pagar',
    'dlg.tr.transfer': 'Transferir',
    'dlg.tr.errPayAccount': 'Selecciona la cuenta que pagará',
    'dlg.tr.errAccounts': 'Selecciona las cuentas de origen y destino',
    'dlg.tr.errSame': 'Origen y destino deben ser diferentes',
    'dlg.tr.errAmount': 'Indica un importe válido',
    'dlg.tr.errReceived': 'Indica el importe recibido en el destino',
    'dlg.tr.paid': 'Factura pagada',
    'dlg.tr.done': 'Transferencia registrada',
    'dlg.tr.error': 'Error al transferir',

    // ImportStatementDialog
    'dlg.imp.title': 'Importar factura (foto o PDF)',
    'dlg.imp.desc':
      'La IA lee la factura y arma la lista de abajo. Revisa categoría e importes e importa todo de una vez a la factura de {month}.',
    'dlg.imp.reading': 'Leyendo la factura…',
    'dlg.imp.sendPrompt': 'Envía la foto o el PDF de la factura',
    'dlg.imp.accepts': 'Acepta imagen (JPG/PNG) o PDF. La IA extrae fecha, descripción, importe y cuotas.',
    'dlg.imp.chooseFile': 'Elegir archivo',
    'dlg.imp.selected': 'seleccionados',
    'dlg.imp.applyCurrencyAll': 'Aplicar moneda a todas',
    'dlg.imp.change': 'Cambiar',
    'dlg.imp.purchases': 'Compras',
    'dlg.imp.refunds': 'reembolsos',
    'dlg.imp.negativeHint': 'importe negativo = reembolso. Revisa antes de importar.',
    'dlg.imp.rowCurrency': 'Moneda de la fila',
    'dlg.imp.removeRow': 'Quitar fila',
    'dlg.imp.errExtract': 'La extracción falló. Prueba una foto más nítida o el PDF.',
    'dlg.imp.errNone': 'Ningún movimiento reconocido. Prueba una imagen más nítida o el PDF de la factura.',
    'dlg.imp.errPickOne': 'Marca al menos un movimiento con fecha e importe.',
    'dlg.imp.importedOne': '{n} movimiento importado',
    'dlg.imp.importedMany': '{n} movimientos importados',
    'dlg.imp.errImport': 'Error al importar',
    'dlg.imp.importing': 'Importando…',
    'dlg.imp.importN': 'Importar {n}',

    // FilterBar
    'dlg.filter.allAccounts': 'Todas las cuentas',
    'dlg.filter.byAccount': 'Filtrar por cuenta',
    'dlg.filter.allCategories': 'Todas las categorías',
    'dlg.filter.byCategory': 'Filtrar por categoría',
    'dlg.filter.tag': 'Etiqueta',
    'dlg.filter.allTags': 'Todas las etiquetas',
    'dlg.filter.type': 'Tipo',
    'dlg.filter.bothKinds': 'Ingresos y gastos',
    'dlg.filter.onlyIncome': 'Solo ingresos',
    'dlg.filter.onlyExpense': 'Solo gastos',
    'dlg.filter.allStatus': 'Todos los estados',
    'dlg.filter.clear': 'Limpiar',

    // ConversionIndicator
    'dlg.conv.ariaConverted': 'Importe convertido',
    'dlg.conv.convertedTo': 'Convertido a {value}',
    'dlg.conv.rateLine': '1 {currency} = {rate} {base}',
  },
}

export default dialogs
